import AfipTiposPage from "./AfipTiposPage";

export {AfipTiposPage}
export default AfipTiposPage
